class EqualHeight {

	constructor(blockEl) {
		this.el = blockEl;
		this.targets = this.el.querySelectorAll('.equal-height-target');
		this.resizeHandler = this.handleResize.bind(this);

		this.init();
	}

	async init() {
		this.equalize();
		window.addEventListener('resize', this.resizeHandler);
	}

	async equalize() {
		this.targets.forEach(target => (target.style.height = 'auto'));

		const maxHeight = await this.getHeights();
		this.equalizeHeights(maxHeight);
	}
	
	async getHeights() {
		let maxHeight = 0; 
		this.targets.forEach(target => {
			const targetHeight = target.offsetHeight;
			if (targetHeight > maxHeight) {
				maxHeight = targetHeight;
			}
		});

		return maxHeight;
	}

	equalizeHeights(maxHeight) {
		this.targets.forEach(target => {
			target.style.height = maxHeight + 'px';
		});
	}

	handleResize() {
		clearTimeout(this.resizeTimeout);
		this.resizeTimeout = setTimeout(() => {
			this.equalize();
		}, 200);
	}

	destroy() {
		window.removeEventListener('resize', this.resizeHandler);
	}

}

export default EqualHeight;